/* eslint-disable max-len */
import React, { useContext, useState } from "react";
import { Tabs } from "antd";
import type { TabsProps } from "antd";
import { useParams, useHistory } from "react-router-dom";

import ResponderTable from "@/components/Table/ResponderTable";
import HeaderComponent from "@/components/Header/Header";
import { usePanicTypes } from "@/hooks/usePanicTypes";
import {
  useAllResponderCompanies,
  useResponderAdmin,
} from "@/hooks/useResponderCompany";
import AuthContext from "@/contexts/AuthContext";

const { TabPane } = Tabs;

type responderParams = {
  companyId: string;
};

function Responders() {
  const history = useHistory();
  const { companyId } = useParams<responderParams>();
  const { user, isCommunityAdmin, isAdmin } = useContext(AuthContext);
  const { data: currentResponderAdmin } = useResponderAdmin(user?.id);
  const responderCompany: IResponderCompany | undefined | null =
    currentResponderAdmin?.responderCompany;
  const panicTypes = usePanicTypes();
  // Will fetch from the backend
  const { data: companies, isLoading, isError } = useAllResponderCompanies();

  const onTabChange = (key: string) => {
    if (isAdmin) {
      if (key.toLowerCase() === "all") {
        history.replace(`/home/responders`);
        return;
      }
      history.replace(`/home/responders/${key}`);
    } else {
      history.replace(`/home/responders/${responderCompany?.id}`);
    }
  };

  return (
    <div className="flex w-full h-full bg-backgroundColor">
      <div className="w-full h-full max-h-screen overflow-y-auto disable-scrollbars">
        <HeaderComponent title="Responders" />
        <Tabs
          defaultActiveKey={companyId || "0"}
          className="px-3"
          onChange={onTabChange}
        >
          {isAdmin ? (
            <>
              <TabPane tab="All" key="0">
                <ResponderTable companyId={0} />
              </TabPane>
              {!!isLoading ? (
                <div>Loading...</div>
              ) : (
                Array.isArray(companies) &&
                companies.map(
                  (responderCompanyItem: IBasicResponderCompanyDto) => (
                    <TabPane
                      tab={responderCompanyItem.companyName}
                      key={responderCompanyItem.id.toString()}
                    >
                      <ResponderTable companyId={responderCompanyItem.id} />
                    </TabPane>
                  )
                )
              )}
            </>
          ) : (
            <>
              <TabPane
                tab={responderCompany?.companyName}
                key={responderCompany?.id?.toString() || "0"}
              >
                <ResponderTable companyId={responderCompany?.id ?? 0} />
              </TabPane>
            </>
          )}
        </Tabs>
      </div>
    </div>
  );
}

export default Responders;
